var _rect, _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAlu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.0000610352,
    width: 44,
    height: 44,
    rx: 4,
    fill: "#E0F6F7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.3978 12.915H26.3754V15.1339L27.4774 17.8631V27.5603L26.3648 31.0404H17.7123L16.4532 27.5722V17.8788L17.3978 15.1496V12.915ZM18.4251 15.8505L17.8958 17.3797H25.988L25.3706 15.8505H18.4251ZM25.1754 14.6505V14.115H18.5978V14.6505H25.1754ZM26.2774 18.5797H17.6532V26.8667H26.2774V18.5797ZM26.0556 28.0667H17.9094L18.5533 29.8404H25.4886L26.0556 28.0667Z",
    fill: "url(#paint0_linear_1392_6249)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1392_6249",
    x1: 21.9653,
    y1: 12.915,
    x2: 21.9653,
    y2: 31.0404,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2DC3E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#47B972"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlu);
export default __webpack_public_path__ + "static/media/alu.fc402869b182160ae7ef834bc9028b29.svg";
export { ForwardRef as ReactComponent };